import { Card } from "@components/cards/card";
import { RaffleMyOwnList } from "@components/raffles/myOwnList";
import { Masks } from "@hooks/functions/Masks/Masks";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { useEffect, useState } from "react";
import { FaCircleInfo, FaExpand, FaMinus } from "react-icons/fa6";
import { Link } from "react-router-dom";

const masks = new Masks();
export function MyRaffleDefaultList() {
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  const [showHowItWorks, setShowHowItWorks] = useState<boolean>(false);

  function inMaintenance() {
    pushToastify({
      message: `Em construção.`,
      type: "info",
      theme: "dark",
    });
  }

  const [isLoading, setIsLoading] = useState({
    card: false,
    raffles: true,
  });

  useEffect(() => {}, []);

  return (
    <>
      {/* Explaining */}
      <div className="row">
        <div className="col-md-12">
          <Card>
            <div
              className="card-header cursor-pointer"
              onClick={() => {
                setShowHowItWorks(!showHowItWorks);
              }}
            >
              <div className="card-title d-flex justify-content-between">
                <span>Como Funciona?</span>
                {showHowItWorks ? (
                  <FaMinus
                    className="ms-1"
                    title="Clique para ocultar o saiba mais."
                  />
                ) : (
                  <FaExpand className="ms-1" title="Clique para saber mais." />
                )}
              </div>
              <div className="card-category">
                Modelo da rifa tradicional como as de papelaria, onde se escolhe
                por número, nome ou outro valor previamente configurado.
              </div>
            </div>
            <div className={`card-body ${showHowItWorks ? `` : `d-none`}`}>
              <div className="row">
                {/* Numeric Raffle */}
                <div className="col-md-6">
                  <div className="h6 text-center">Rifa Numérica</div>
                  <div className="d-flex flex-column">
                    <span>Informações sobre:</span>
                    <ul>
                      <li>A rifa será composta por uma sequência numérica.</li>
                      <li>
                        Cada ticket numérico pertencerá, única e exclusivamente,
                        a um usuário.
                        <FaCircleInfo
                          className="ms-1"
                          title="Ao primeiro usuário que concluir a compra."
                        />
                      </li>
                    </ul>
                  </div>
                  <div className="form-group">
                    <Link to="/raffle/default/number/preview?campaign=test-iphone-ipad-nf&key=ZVBaWw">
                      <button
                        className="btn btn-sm btn-info form-control"
                        title="Limpar todos os filtros."
                      >
                        Mais informações
                      </button>
                    </Link>
                  </div>
                </div>

                {/* People's Name Raffle */}
                <div className="col-md-6">
                  <div className="h6 text-center">Rifa de Palavras</div>
                  <div className="d-flex flex-column">
                    <span>Informações sobre:</span>
                    <ul>
                      <li>
                        A rifa será composta por <strong>nomes</strong> ou{" "}
                        <strong>palavras</strong> aleatórios(as).
                      </li>
                      <li>
                        Cada ticket pertencerá, única e exclusivamente, a um
                        usuário.
                        <FaCircleInfo
                          className="ms-1"
                          title="Ao primeiro usuário que concluir a compra."
                        />
                      </li>
                    </ul>
                  </div>
                  <div className="form-group">
                    <Link to="/raffle/default/word/preview?campaign=test-iphone-netflix&key=ZVBaWg">
                      <button
                        className="btn btn-sm btn-success form-control"
                        title="Limpar todos os filtros."
                      >
                        Mais informações
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>

      {/* My Raffles */}
      <div className="row">
        <div className="col-md-12">
          <RaffleMyOwnList />
        </div>
      </div>
    </>
  );
}
